import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Form, reduxForm, formValueSelector, getFormSyncErrors, getFormMeta } from 'redux-form';
import OtpInput from 'react-otp-input';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Loader from '../../Common/Loader/Loader';
import Link from '../../Link/Link';

import { closeHeaderModal } from '../../../actions/siteadmin/modalActions';
import { sendVerificationSms } from '../../../actions/login/sendVerificationSms';

import submit from './submit';
import messages from '../../../locale/messages';
import { encode } from '../../../helpers/queryEncryption';
import { auth } from '../../../config-server';
import useQueryResponse from '../../../lib/hooks/useQueryResponse';
import { getActiveSmsMethods } from '../../../lib/graphql';
import bt from '../../commonStyle.css';
import s from '../../../styles/optInput.css'


function VerifyPhoneNumberForm(props) {
    const {
        handleSubmit,
        change,
        intl: { formatMessage },
        loading,
        phoneNumber,
        phoneDialCode,
        preferredLanguage,
        closeHeaderModal,
        sendVerificationSms,
        referUrl
    } = props

    const [verificationCode, setVerificationCode] = useState('');

    const { data, loading: smsLoading } = useQueryResponse({
        query: getActiveSmsMethods,
        ssr: false,
        fetchPolicy: 'network-only'
    })

    useEffect(() => {
        referUrl && change('referUrl', referUrl);
    })

    const handleChange = (verificationCode) => {

        setVerificationCode(verificationCode)
        change('verificationCode', verificationCode);
        change('phoneNumber', phoneNumber);
        change('phoneDialCode', phoneDialCode);
        change('preferredLanguage', preferredLanguage);
    }

    const handleClick = () => {
        let prefillLogin = true;
        closeHeaderModal('verifyPhoneNumber', prefillLogin);
    }

    const handlePrefill = () => {
        const prefillCode = 1234;
        setVerificationCode(prefillCode)
        change('verificationCode', prefillCode);
        change('phoneNumber', phoneNumber);
        change('phoneDialCode', phoneDialCode);
        change('preferredLanguage', preferredLanguage);
    }

    const handleResend = (e) => {
        e.preventDefault();
        let userType = 1, isResendOtp = true, jwtToken = encode(auth?.jwt?.secret);
        sendVerificationSms({ phoneDialCode, phoneNumber, userType, isResendOtp, jwtToken })
    }
    const isActiveSmsMethods = !smsLoading && data?.getActiveSmsMethods?.results[0].id
    return (
        <div className={bt.spaceTop2}>
            <div className={cx(bt.commonSmallHeading, bt.space3, bt.textAlignCenter)}><FormattedMessage {...messages.enterOtp} /> {phoneDialCode} {phoneNumber}</div>
            <Form onSubmit={handleSubmit}>
                <div className='optContainer'>
                    <OtpInput
                        value={verificationCode}
                        onChange={handleChange}
                        numInputs={4}
                        renderInput={(props) => <input {...props} />}
                        inputType={'text'}
                        autoComplete="off"
                    />
                </div>
                {isActiveSmsMethods == 1 && <div className={"optNumberContainer"}><div onClick={handlePrefill} className='optNumberWrapper'> <FormattedMessage {...messages.otpLabel} /></div></div>}
                <div className={cx('optResendContainer')}>
                    <div className={cx('optResendText')}><FormattedMessage {...messages.otpNotReceiveLabel} /></div>
                    <Link to={''} onClick={(e) => handleResend(e)} className={cx(bt.commonCardLink)}>
                        <FormattedMessage {...messages.resend} />
                    </Link>
                </div>
                <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                    <Button onClick={handleClick} className={cx(bt.btnSecondary)}>
                        <FormattedMessage {...messages.back} />
                    </Button>
                    <Loader
                        type="button"
                        buttonType="submit"
                        show={loading}
                        label={formatMessage(messages.verify)}
                        className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                    />
                </div>
            </Form>
        </div>
    )
}
VerifyPhoneNumberForm = reduxForm({
    form: 'VerifyPhoneNumberForm',
    destroyOnUnmount: false,
    onSubmit: submit
})(VerifyPhoneNumberForm);

const selector = formValueSelector('VerifyPhoneNumberForm');
const loginSelector = formValueSelector('LoginForm');


const mapState = state => ({
    loading: state.loader.verifyOtpLoading,
    verificationCode: selector(state, 'verificationCode'),
    fieldErrors: getFormSyncErrors('VerifyPhoneNumberForm')(state),
    fieldMeta: getFormMeta('VerifyPhoneNumberForm')(state),
    phoneNumber: loginSelector(state, 'phoneNumber'),
    phoneDialCode: loginSelector(state, 'phoneDialCode'),
    preferredLanguage: state.runtime.availableLocales[0],
    verifyPhoneNumber: state.adminModalStatus.verifyPhoneNumber,
    referUrl: loginSelector(state, 'referUrl')
});

const mapDispatch = {
    closeHeaderModal,
    sendVerificationSms
};

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(VerifyPhoneNumberForm)));